"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeNavigation_de_de = void 0;
function backofficeNavigation_de_de() {
    return {
        "backoffice.navigation.company": "Firma",
        "backoffice.navigation.companysettings": "Firmeneinstellungen",
        "backoffice.navigation.projectsettings": "Projekteinstellungen",
        "backoffice.navigation.invoices": "Rechnungen",
        "backoffice.navigation.projects": "Projekte",
        "backoffice.navigation.overview": "Übersicht",
        "backoffice.navigation.internationalization": "Internationalisierung",
        "backoffice.navigation.localizations": "Übersetzungen",
        "backoffice.navigation.languages": "Sprachen",
        "backoffice.navigation.cms": "CMS Seiten",
        "backoffice.navigation.websites": "Webseiten",
        "backoffice.navigation.products": "Produkte",
        "backoffice.navigation.roles": "Rollen",
        "backoffice.navigation.companyroles": "Firmenrollen",
        "backoffice.navigation.companyrolessubtitle": "Rollen der Firma ",
        "backoffice.navigation.projectroles": "Projektrollen",
        "backoffice.navigation.projectrolessubtitle": "Rollen des Projektes ",
        "backoffice.navigation.configuration": "Konfiguration",
        "backoffice.navigation.files": "Dateien",
        "backoffice.navigation.projectfiles": "Projektdateien",
        "backoffice.navigation.companyfiles": "Firmendateien",
        "backoffice.navigation.users": "Benutzer",
        "backoffice.navigation.noproject": "Keine Projekte vorhanden",
        "backoffice.navigation.modules": "Weitere Module",
        "backoffice.navigation.ownmodules": "Eigene Module",
        "backoffice.navigation.checkin": "Check-In App",
        "backoffice.navigation.forms": "Formulare",
        "backoffice.navigation.pim": "E-Commerce",
        "backoffice.navigation.content": "Inhalt",
        "backoffice.navigation.tasks": "Aufgaben",
        "backoffice.navigation.taskqueue": "Warteschlange",
        "backoffice.navigation.applications": "Applikationen",
        "backoffice.navigation.favorites": "Favoriten",
        "backoffice.navigation.members": "Mitarbeiter",
        "backoffice.navigation.projectmembers": "Projektmitarbeiter",
        "backoffice.navigation.companymembers": "Firmenmitarbeiter",
        "backoffice.navigation.servicetokens": "Servicetokens",
        "backoffice.navigation.customizationmode": "Anpassungsmodus",
        "backoffice.topnav.addcompany": "Firma hinzufügen",
        "backoffice.topnav.showallcompanies": "Zur Firmenübersicht",
        "backoffice.topnav.showallprojects": "Zur Projektübersicht",
        "backoffice.topnav.addproject": "Projekt hinzufügen",
        "backoffice.topnav.myprofile": "Mein Profil",
        "backoffice.topnav.messages": "Meine Nachrichten",
        "backoffice.topnav.mytasks": "Meine Aufgaben",
        "backoffice.topnav.reseller": "Reseller Dashboard",
        "backoffice.topnav.logout": "Ausloggen",
        "backoffice.topnav.companyprofile": "Firmenprofil",
        "backoffice.footer.helplink": "Bug melden"
    };
}
exports.backofficeNavigation_de_de = backofficeNavigation_de_de;
